import React from 'react';
import { Route, Redirect } from "react-router-dom";

const GuardedAdminAdmission = ({ component: Component, ...rest }) => (
    <Route {...rest} render={(props) => (
        localStorage.getItem('tokenSecurity_admission')
            ? <Component {...props} />
            : <Redirect to='/admision/admin' />
    )} />
)

export default GuardedAdminAdmission;